import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './print.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './context/AppContext';
import { ScreenReaderProvider } from './context/ScreenReaderContext';
import { BrowserRouter } from 'react-router';
import { FontSizeProvider } from './context/FontSizeContext';
import { Provider } from "react-redux";
import { store } from "./store/store";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppProvider>
        <FontSizeProvider>
          <ScreenReaderProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ScreenReaderProvider>
        </FontSizeProvider>
      </AppProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
